import React, { Suspense } from 'react';
import { Router, Switch, Route } from 'react-router-dom';

import PrivateRoute from 'components/PrivateRoute';
import { useAuth } from 'contexts/auth';
import LoggedLayout from 'layouts/LoggedLayout';
import config from './config';
import { Box, CircularProgress } from '@material-ui/core';
import { DEFAULT_PROFILE } from 'utils/constants';
import history from 'services/history';

function Routes() {
  const { loading = true, profiles } = useAuth();
  const isAssociado = profiles.includes(DEFAULT_PROFILE);

  const protectedRoutes = config.protected.filter(route =>
    route.profiles
      ? profiles.some(profile => route.profiles?.some(item => item === profile))
      : true,
  );

  if (loading) return null;

  return (
    <Router history={history}>
      <Suspense
        fallback={
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        }
      >
        <Switch>
          {config.public.map(({ component: Component, ...rest }, i) => (
            <Route key={i} {...rest}>
              <Component />
            </Route>
          ))}
          <LoggedLayout routes={protectedRoutes}>
            <Switch>
              {!isAssociado
                ? protectedRoutes.map(
                    ({ component: Component, ...rest }, i) => (
                      <PrivateRoute key={i} {...rest}>
                        <Component />
                      </PrivateRoute>
                    ),
                  )
                : protectedRoutes
                    .filter(
                      item =>
                        item.title === 'Associado Dashboard' ||
                        item.title === 'Notificacoes' ||
                        item.title === 'Associado Sorteio',
                    )
                    .map(({ component: Component, ...rest }, i) => (
                      <PrivateRoute key={i} {...rest}>
                        <Component />
                      </PrivateRoute>
                    ))}
            </Switch>
          </LoggedLayout>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default Routes;
